import Vue from "vue";
import Vuex from "vuex";
import VueCroppie from "vue-croppie";
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
import PortalVue from "portal-vue";
import VueMq from "vue-mq";
import Vuency from "vuency";
import VueClipboard from "vue-clipboard2";
import VueLazy from "vue-lazyload";
import api from "@/services/api";
import domainConfig from "../../../domain-config.json";


import {
  convertAllElements,
  convertElement,
  destroyElement,
  getComponentByName,
} from "./vue-launcher.js";

import AthleteProfilePage from "@/components/AthleteProfile/AthleteProfilePage";
import AthleteSearch from "@/components/AthleteSearch/Search";
import AthleteSearchMobileNavIcon from "@/components/AthleteSearch/MobileNavIcon";

import formatDate from "@/filters/formatDate";
import ago from "@/filters/ago";
import commaAnd from "@/filters/commaAnd";
import formatHeight from "@/filters/formatHeight";

// Directives
import show from "@/directives/show";
import preventBodyScroll from "@/directives/preventBodyScroll";

momentDurationFormatSetup(moment);

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(PortalVue);
Vue.use(VueCroppie);
Vue.use(Vuency);
Vue.use(VueClipboard);
Vue.use(VueLazy, {
  observer: true,
  observerOptions: {
    rootMargin: "0px",
    threshold: 0.1,
  },
});

const breakpoints = {
  mobile: 768,
  desktop: Infinity,
  "2xs": 440,
  xs: 640,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1281,
};

Vue.use(VueMq, { breakpoints });

Vue.mixin({
  methods: {
    $media(min) {
      const goodPoints = Object.keys(breakpoints).filter(
        (name) => breakpoints[name] >= breakpoints[min]
      );
      return goodPoints.includes(this.$mq);
    },
    $breakpoint(breakpoint) {
      return breakpoints[breakpoint];
    },
  },
});

Vue.directive("prevent-body-scroll", preventBodyScroll);
Vue.directive("show", show);

Vue.filter("formatHeight", formatHeight);
Vue.filter("formatDate", formatDate);
Vue.filter("ago", ago);
Vue.filter("commaAnd", commaAnd);

let elementConfig = {
  AthleteProfilePage,
  AthleteSearch,
  AthleteSearchMobileNavIcon
};

window.elementConfig = elementConfig;

document.addEventListener("DOMContentLoaded", function () {
  convertAllElements(elementConfig);
});

const currentDomain = _.get(api.clientData("domain"), "slug", "sportsrecruits");
Vue.prototype["$domain"] = {
  component(name) {
    return getComponentByName(name, window.elementConfig);
  },
  config(key, defaultVal) {
    return _.get(domainConfig, `${currentDomain}.${key}`, defaultVal);
  },
  current() {
    return api.clientData("domain");
  },
};

Vue.prototype["$window"] = window;

window.mountVue = (element, config = {}) =>
  convertElement(element, elementConfig, config);
window.dismountVue = (element) => destroyElement(element);
